// PDP safety guards. Loaded on every page from snippets/bb-head.liquid.
//
// 1. THE STICKY BAR COULD TAKE AN ORDER THE MAIN BUTTON WAS REFUSING (Sep 17).
//    `#sbBtn` called form.requestSubmit() directly, and requestSubmit() is not affected by another
//    button's disabled state. On a phone (the sticky bar is display:none on desktop) a shopper
//    could tap it while `#add` was disabled and submit:
//      * a 3-Pack with `properties[Your 3 colours]` EMPTY — a $99.99/$149.99 order, no colours
//      * any combination the section had already marked unavailable
//    Capture-phase, so it runs before the section's own handler and can stop it.
//
// 2. SOLD-OUT SHADES LOOKED BUYABLE (Sep 17). Six of the Sculpt Legging's eleven colours have no
//    purchasable variant at all — every size out of stock — but their swatches looked identical
//    to the five that work. A shopper picks Pink, the gallery changes, and only then does Add to
//    bag read "Sold out". The swatch now carries data-oos and is struck through; the label says
//    which shade is unavailable. Derived from the variant JSON the section already prints, so it
//    stays correct as stock changes — nothing is hard-coded.
(function () {
  function boot() {
    var add = document.getElementById('add');

    // ---- 1. sticky guard -------------------------------------------------
    var sb = document.getElementById('sbBtn');
    if (sb && add) {
      sb.addEventListener('click', function (e) {
        if (!add.disabled) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var err = document.getElementById('bberr');
        var box = document.getElementById('packcolours');
        var target = (box && !box.hidden) ? box
                   : (err && err.style.display !== 'none' ? err : add);
        if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (err && err.style.display !== 'none' && err.animate) {
          err.animate([{opacity:1},{opacity:.25},{opacity:1},{opacity:.25},{opacity:1}], {duration:700});
        }
      }, true);

      function mirror() {
        sb.disabled = add.disabled;
        sb.textContent = add.disabled
          ? ((document.getElementById('addTxt') || {}).textContent || 'Unavailable').trim()
          : 'Add to bag';
      }
      new MutationObserver(mirror).observe(add, { attributes: true, attributeFilter: ['disabled'] });
      mirror();
    }

    // ---- 2. mark shades that cannot be bought ----------------------------
    var shades = document.getElementById('shades');
    var raw = document.getElementById('bb-variants');
    if (!shades || !raw) return;
    var VAR = [];
    try { VAR = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!VAR.length) return;

    // which option index is the shade? the one whose values match the swatches
    var names = [].map.call(shades.children, function (b) { return b.getAttribute('data-shade'); });
    var idx = -1;
    for (var i = 0; i < 3; i++) {
      if (VAR[0].options && names.indexOf(VAR[0].options[i]) > -1) { idx = i; break; }
    }
    if (idx < 0) return;

    [].forEach.call(shades.children, function (b) {
      var name = b.getAttribute('data-shade');
      var anyAvailable = VAR.some(function (v) {
        return v.options && v.options[idx] === name && v.available;
      });
      if (!anyAvailable) {
        b.setAttribute('data-oos', '1');
        b.setAttribute('title', name + ' — sold out');
        var lab = b.getAttribute('aria-label') || name;
        b.setAttribute('aria-label', lab + ', sold out');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();